<template lang="pug">
.dashboard-wrapper
  b-row
    b-col
      b-card(no-body, class="pt-2 px-2")
        filters(
          :customFiltersShow="true"
          :zoneFilterShow="zone_agency_filter"
          :agencyFilterShow="zone_agency_filter"
          :locationFilterShow="userRole === 'consultant' ? true : false",
          :dateRangeFilterShow="true",
          :locationDefaultValue="true",
          :physicalLocationFilterShow="true"
          :areaFilterShow="true"
          @changeFilter="updateFilter",
          @locations="updateLocations"
        )

  b-row(v-if="isLoading")
    b-col
      b-card(class="py-5")
        loading(
          :active="true" 
          :is-full-page="false"
          :color="colors.primary"
        )

  div(v-else)
    b-row(v-if="!meetings_total")
      b-col
        b-card(class="text-center")
          h5(class="mb-0")
            | {{ $t('message.no_daily_dialogues_found') }}

    div(v-else)
      b-row
        b-col(sm)
          statistic-card-vertical-total(:statistic="meetings_total")
        b-col(sm)
          statistic-card-vertical-index(:statistic="happiness_index")
        b-col(sm)
          statistic-card-vertical-compliance(:statistic="compliance")
        b-col(sm)
          statistic-card-vertical-comments(:statistic="comments_total")
        b-col(sm)
          statistic-card-vertical-unique-comments(:statistic="comments_unique")

      b-card.text-primary(
        v-if="selectedLocationsData.length",
        class="hover-card",
        @click="showComplianceDetails = !showComplianceDetails",
        style="cursor: pointer; user-select: none;"
      ) 
        feather-icon(
          :icon="showComplianceDetails ? 'ChevronUpIcon' : 'ChevronDownIcon'",
          size="18"
        )
        span.pl-4
          | {{ `${showComplianceDetails ? $t('Hide') : $t('View')} ${$t('message.complianceDetail')}` }}

        b-table-simple.mt-2(v-if="showComplianceDetails", hover, small, caption-top, responsive)
          b-thead(head-variant="light")
            b-tr
              th {{ $t('happiness.location') }}
              th {{ $t('happiness.dailyGoal') }}
              th {{ $t('happiness.daysOfWeek') }}
              th {{ $t('happiness.daysConsidered') }}
              th {{ $t('happiness.expectation') }}
              th {{ $t('happiness.done') }}
              th {{ $t('happiness.compliance') }}
            b-tr(v-for="(item, index) in selectedLocationsData", :key="index")
              b-td {{ item.location }}
              b-td {{ item.dailyDialoguesCount }}
              b-td {{ (item.dailyDialogueDays && item.dailyDialogueDays.length) ? item.dailyDialogueDays.map(e => $t(`happiness.${e}`)).join(', ') : '-' }}
              b-td {{ item.qDays || '-' }}
              b-td {{ item.expectedDialogues || '-' }}
              b-td {{ item.actualDialogues || '-' }}
              b-td {{ item.compliance || '-' }}

      b-row
        b-col(lg="6")
          bar-chart-location(
            v-if="locationDialogues.labels && locationDialogues.labels.length",
            :locations-data="locationDialogues"
          )
        b-col(lg="6")
          bar-chart-happiness(
            v-if="locationHappiness.labels && locationHappiness.labels.length",
            :happiness-data="locationHappiness"
          )
      b-row
        b-col(cols="12")
          heat-map-dialogues(
            v-if="dialoguesPerDay.length",
            :dialogues-per-day-data="dialoguesPerDay"
            :default-language="default_language"
          )

      b-card
        feather-icon-button(v-if="commentsVisible", icon="ArrowLeftIcon", variant="info", size="21", class="mb-1" @clicked="handleComments(false)")
        b-table-simple(hover, small, caption-top, responsive)
          b-thead(v-if="!commentsVisible", head-variant="light")
            b-tr
              th {{ $t('happiness.date') }}
              th {{ $t('happiness.start_time') }}
              th {{ $t('happiness.end_time') }}
              th {{ $t('happiness.created_by') }}
              th {{ $t('happiness.physical_location') }}
              th {{ $t('happiness.location') }}
              th {{ $t('happiness.happy') }}
              th {{ $t('happiness.neutral') }}
              th {{ $t('happiness.sad') }}
              th {{ $t('happiness.mood') }}
              th(v-if="behaviorFunctionalityDD") {{ $t('message.behaviour_suggestion') }}
              th {{ $t('label.load') }}
              th {{ $t('happiness.image') }}
              th {{ $t('happiness.action') }}
            b-tr(v-for="(meeting, index) in meetings", :key="index")
              b-td {{ meeting.dateString }}
              b-td {{ meeting.start_time }}
              b-td {{ meeting.end_time }}
              b-td {{ meeting.created_by }}
              b-td {{ meeting.physical_location || '-' }}
              b-td {{ meeting.location }}
              b-td {{ meeting.happy }}
              b-td {{ meeting.neutral }}
              b-td {{ meeting.sad }}
              b-td {{ meeting.happiness_index_text() }}
              b-td(v-if="behaviorFunctionalityDD")
                span.behaviour-link(
                  v-if="meeting.suggested_behaviour_name"
                  @click="openBehaviourDetail(meeting.suggested_behaviour_id)"
                ) {{ meeting.suggested_behaviour_name }}
                span(v-else) -
              b-td {{ meeting.partial ? $t('label.partial') : $t('label.complete') }}
              b-td(v-if="meeting.imageKey")
                b-button(
                    size="sm",
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'",
                    type="button",
                    variant="primary",
                    @click="openImage(meeting.imageKey)"
                    style="width: 5.5rem"
                  )
                    | {{ $t('message.open') }}            
              b-td(v-else)
                b-button(
                  size="sm",
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'",
                  type="button",
                  variant="info",
                  v-b-modal="'uploadImg' + index"
                  @click="openModal"
                  style="width: 5.5rem"
                )
                  | {{ $t('message.upload') }}
                b-modal(
                  :id="'uploadImg' + index"
                  centered
                  no-close-on-backdrop
                  modal-class="modal-info"
                  ok-variant="info"
                  cancel-variant="outline-secondary"
                  :title="$t('message.confirm_action')"
                  ok-title="OK"
                  :cancel-title="$t('message.cancel')"
                  :ok-disabled="!imgData.fileInfo"
                  @ok="saveImgInAWS(meeting.id)"
                  @hide="hideAction()"
                )
                  b-td(class="d-flex flex-column")
                    small(v-if="imgData.fileInfo") {{ $t('message.nameImg') }}: {{ imgData.fileInfo.name }}
                    div(class="align-self-start mt-2")
                      b-button(
                        @click="uploadImage()"
                        variant="light"
                        class=""
                      ) {{ imgData.fileInfo ? $t('message.modify') : $t('Upload') }}
              b-td
                delete-button(v-if="userRole === 'consultant'", v-b-modal="`modal ${index}`")
                b-modal(
                  v-if="userRole === 'consultant'"
                  :id="`modal ${index}`"
                  centered
                  no-close-on-backdrop
                  modal-class="modal-danger"
                  ok-variant="danger"
                  cancel-variant="outline-secondary"
                  :title="$t('message.confirm_action')"
                  :ok-title="$t('message.delete')"
                  :cancel-title="$t('message.cancel')"
                  @ok="deleteMeeting(meeting.id, meeting.improvements, meeting.recognitions)"
                )
                  | {{ $t('message.confirm_delete_daily_dialogue') }}
                feather-icon-button(
                  v-if="canSeeComments && meeting.employeeSurveys && meeting.employeeSurveys.length",
                  icon="MessageSquareIcon",
                  variant="info",
                  @clicked="handleComments(true, meeting.employeeSurveys)"
                )
            image-compressor(
              style="display: none",
              :done="getImgCompressed",
              ref="compressor"
            )
          b-thead(v-else, head-variant="light")
            b-tr
              th {{ $t('happiness.date') }}
              th {{ $t('happiness.location') }}
              th {{ $t('message.tableHeader.state') }}
              th {{ $t('message.tableHeader.comments') }}
            b-tr(v-for="(survey, index) in employeeSurveysSelected", :key="index")
              b-td {{ survey.date }}
              b-td {{ survey.location }}
              b-td(:class="stateVariants[survey.answer]") {{ $t(`happiness.${survey.answer}`) }}
              b-td(:class="stateVariants[survey.answer]") {{ survey.comment }}

      b-button(class="mr-4 mb-1", :disabled="!meetings.length")
        json-excel(:data="meetings", :fields="excelFieldsDialogues")
          | {{ $t('download_xlsx_daily_dialogues') }}

      b-button(v-if="canSeeComments", class="mr-4 mb-1", :disabled="!totalEmployeeSurveys.length")
        json-excel(:data="totalEmployeeSurveys", :fields="excelFieldsComments")
          | {{ $t('download_xlsx_comments') }}
</template>

<script>
import { onMounted, ref } from "@vue/composition-api/dist/vue-composition-api";
import store from "@/store";
import useNotifications from "@/composables/useNotifications";
import { BTable, BTableSimple, BThead, BTr, BTd, BCard, BModal, VBModal } from "bootstrap-vue";
import JsonExcel from "vue-json-excel";
import StatisticCardVerticalTotal from './charts/StatisticCardVerticalTotal.vue'
import StatisticCardVerticalIndex from './charts/StatisticCardVerticalIndex.vue'
import StatisticCardVerticalCompliance from './charts/StatisticCardVerticalCompliance.vue'
import StatisticCardVerticalComments from './charts/StatisticCardVerticalComments.vue'
import StatisticCardVerticalUniqueComments from './charts/StatisticCardVerticalUniqueComments.vue'
import BarChartLocation from './charts/ChartjsHorizontalBarChartLocation.vue'
import BarChartHappiness from './charts/ChartjsHorizontalBarChartHappiness.vue'
import Filters from "@/views/organization/Filters.vue";
import i18n from '@/libs/i18n'
import Ripple from 'vue-ripple-directive'
import useCommonDashboards from '@/views/habit/useCommonDashboards'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DeleteButton from '@/views/components/Shared/Buttons/DeleteButton'
import FeatherIconButton from '@/views/components/Shared/Buttons/FeatherIconButton'
import { useRouter } from '@core/utils/utils'
import useCommon from '@/views/organization/useCommon'
import { get } from 'idb-keyval';
import HeatMapDialogues from './charts/ApexHeatMapDialogues.vue'
import ImageCompressor from '@/views/habit/ImageCompressor.vue'
import { colors } from '@/constants'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'
import useCommonTodo from '@/views/apps/todo/useCommonTodo'

export default {
  components: {
    BTable,
    BTableSimple,
    BThead,
    BTr,
    BTd,
    BCard,
    BModal,
    JsonExcel,
    StatisticCardVerticalTotal,
    StatisticCardVerticalIndex,
    StatisticCardVerticalCompliance,
    StatisticCardVerticalComments,
    StatisticCardVerticalUniqueComments,
    BarChartLocation,
    BarChartHappiness,
    Filters,
    Loading,
    DeleteButton,
    FeatherIconButton,
    HeatMapDialogues,
    ImageCompressor,
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  setup() {
    const { router } = useRouter()
    const userData = store.state?.userStore?.userData;
    const userRole = userData.role;
    const client_id = userRole !== "admin" ? userData.client.$oid : null;
    const worker_id = userData.worker_id?.$oid || null;
    const userLocations = userData.locations?.length ? userData.locations : null;
    const hideComments = userData.hideComments;
    // Only Consultant, Director/VP and platform Admin can see comments
    const canSeeComments = !hideComments && ['consultant', 'director'].includes(userRole)
    const { showSuccessMessage, showErrorMessage } = useNotifications();
    const { handleError, openImage, formatIsoDate } = useCommon()
    const { getDatesFromRange, formatDateUTC, dateDiffInDays, happinessIndex, updateDailyDialogueWithKey } = useCommonDashboards()
    const { getItemsAggregate, updateItem, updateItems, getItems } = useLambda()
    const { uploadFileToS3 } = useCommonTodo()
    const meetings = ref([]);
    const meetings_total = ref(0);
    const happiness_index = ref(0)
    const compliance = ref(0)
    const locations = ref([])
    get('locations').then(response => {
      if (response) locations.value = response
      else if (localStorage.locations) locations.value = JSON.parse(localStorage.locations)
    })
    const locationFilter = ref(userLocations ? userLocations.map(e => e.value) : []);
    const physicalLocationFilter = ref([]);
    const zoneFilter = ref([]);
    const agencyFilter = ref([]);
    const locationDialogues = ref({})
    const locationHappiness = ref({})
    const now = new Date()
    const currentMonth = now.getMonth()
    const currentYear = now.getFullYear()
    const lastDayOfMonthDate = new Date(currentYear, currentMonth + 1, 0)
    const lastDayOfMonthNumber = lastDayOfMonthDate.getDate()
    const dateRangeFilter = ref(`01-${currentMonth + 1}-${currentYear} to ${lastDayOfMonthNumber}-${currentMonth + 1}-${currentYear}`)
    const isLoading = ref(true)
    const dialoguesPerDay = ref([])
    const { zone_agency_filter, default_language, behavior_functionality_daily_dialogue: behaviorFunctionalityDD } = JSON.parse(localStorage.getItem('clientData') || '{}')
    const commentsVisible = ref(false)
    const employeeSurveysSelected = ref([])
    const totalEmployeeSurveys = ref([])
    const comments_total = ref(0)
    const comments_unique = ref(0)
    const stateVariants = { happy: 'text-success', neutral: 'text-warning', sad: 'text-danger' }
    const allLocationsData = ref([])
    const selectedLocationsData = ref([])
    const showComplianceDetails = ref(false)
    const excelFieldsDialogues = ref({
      [i18n.t('happiness.date')]: "dateString",
      [i18n.t('happiness.start_time')]: "start_time",
      [i18n.t('happiness.end_time')]: "end_time",
      [i18n.t('happiness.created_by')]: "created_by",
      [i18n.t('happiness.location')]: "location",
      [i18n.t('happiness.physical_location')]: "physical_location",
      [i18n.t('happiness.happy')]: "happy",
      [i18n.t('happiness.neutral')]: "neutral",
      [i18n.t('happiness.sad')]: "sad",
      [i18n.t('happiness.mood')]: "happiness_index",
      [i18n.t('happiness.id')]: "id",
    })
    const excelFieldsComments = ref({
      [i18n.t('happiness.date')]: "date",
      [i18n.t('happiness.location')]: "location",
      [i18n.t('happiness.physical_location')]: "physical_location",
      [i18n.t('message.tableHeader.state')]: "answer",
      [i18n.t('message.tableHeader.comments')]: "comment",
    })

    // To upload image to AWS
    const compressor = ref(null)
    const imgData = ref({})
    
    async function listMeetings() {
      isLoading.value = true
      const [startFilter, endFilter] = getDatesFromRange(dateRangeFilter.value)

      try {
        const initialQuery = {
          client_id: oid(client_id),
          deleted: { $ne: true },
          date: { $gte: date(startFilter), $lt: date(endFilter) },
        }

        const finalQuery = {}

        if (locationFilter.value.length > 0) {
          finalQuery['location._id'] = { $in: locationFilter.value }
        }

        if (physicalLocationFilter.value.length > 0) {
          finalQuery['physical_location._id'] = { $in: physicalLocationFilter.value }
        }

        if (zoneFilter.value.length > 0) {
          finalQuery['location.zone'] = { $in: zoneFilter.value }
        }

        if (agencyFilter.value.length > 0) {
          finalQuery['location.agency'] = { $in: agencyFilter.value }
        }

        const pipeline = [
          { $match: initialQuery },
          {
            $lookup: {
              from: 'location',
              localField: 'location',
              foreignField: '_id',
              pipeline: [
                { $project: { location: 1, zone: 1, agency: 1, dailyDialoguesCount: 1, physical_location: 1 } },
                {
                  $lookup: {
                    from: 'physical_location',
                    localField: 'physical_location',
                    foreignField: '_id',
                    pipeline: [ { $project: { name: 1 } }, { $addFields: { _id: { $toString: "$_id" } } }],
                    as: 'physical_location'
                  }
                },
                { $addFields: { _id: { $toString: "$_id" }, physical_location: { $arrayElemAt: ["$physical_location", 0] } } }
              ],
              as: 'location'
            }
          },
          {
            $lookup: {
              from: 'physical_location',
              localField: 'physical_location',
              foreignField: '_id',
              pipeline: [  { $project: { name: 1 } },  { $addFields: { _id: { $toString: "$_id" } } } ],
              as: 'physical_location',
            },
          },
          { $match: finalQuery },
          {
            $lookup: {
              from: 'worker',
              localField: 'created_by',
              foreignField: '_id',
              pipeline: [ { $project: { name: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ],
              as: 'created_by'
            }
          },
          {
            $lookup: {
              from: 'employee_survey',
              localField: 'employeeSurveys',
              foreignField: '_id',
              pipeline: [
                { $project: { answer: 1, comment: 1, createdAt: 1 , location: 1, physical_location: 1, deviceId: 1 } },
                {
                  $lookup: {
                    from: 'location',
                    localField: 'location',
                    foreignField: '_id',
                    pipeline: [ { $project: { location: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ],
                    as: 'location',
                  },
                },
                {
                  $lookup: {
                    from: 'physical_location',
                    localField: 'physical_location',
                    foreignField: '_id',
                    pipeline: [  { $project: { name: 1 } },  { $addFields: { _id: { $toString: "$_id" } } } ],
                    as: 'physical_location',
                  },
                },
                { $addFields: {
                  _id: { $toString: "$_id" },
                  location: { $arrayElemAt: ["$location", 0] },
                  physical_location: {
                    $cond: {
                      if: { $isArray: "$physical_location" },
                      then: { $arrayElemAt: ["$physical_location", 0] },
                      else: "$physical_location"
                    }}
                } }
              ],
              as: 'employeeSurveys'
            }
          },
          {
            $lookup: {
              from: 'behaviour',
              localField: 'suggested_behaviour_id',
              foreignField: '_id',
              pipeline: [
                { $project: { name: 1 } },
                { $addFields: { _id: { $toString: '$_id' } } },
              ],
              as: 'suggested_behaviour',
            },
          },
          { $addFields: {
            _id: { $toString: "$_id" },
            location: { $arrayElemAt: ["$location", 0] },
            physical_location: {
              $cond: {
                if: { $isArray: "$physical_location" },
                then: { $arrayElemAt: ["$physical_location", 0] },
                else: "$physical_location"
              }
            },
            created_by: { $arrayElemAt: ["$created_by", 0] },
            suggested_behaviour: { $arrayElemAt: ["$suggested_behaviour", 0] },
          } },
          { $sort: { date: 1 } },
        ]
      
        const items = await getItemsAggregate({ collection: 'meeting', pipeline })
        
        await parseMeetingData(items, startFilter, endFilter)
      } catch (error) {
        console.log(error);
        handleError({ error, defaultMessage: i18n.t('message.err_daily_dialogues_list') })
      } finally {
        isLoading.value = false
      }
    }

    async function parseMeetingData(items, startFilter, endFilter) {
      let dailyDialoguesData = { total: 0 }
      let dynamicDate = new Date(startFilter)

      // Generate all dates in the range using UTC to avoid timezone issues
      while (dynamicDate < endFilter) {
        const dateToAdd = formatDateUTC(dynamicDate, default_language)
        dailyDialoguesData[dateToAdd] = { dialogues: 0, images: 0, mood: 0, improvements: 0, recognitions: 0 }
        dynamicDate.setUTCDate(dynamicDate.getUTCDate() + 1)
      }

      let meetings_data = []
      let happiness_data = {happy: 0, neutral: 0, sad: 0}
      let locationData = {}
      let locationDataDaily = {}
      let employeeSurveysData = []

      for (const meeting of items) {
        const date = new Date(meeting.date)
        const dateString = formatDateUTC(date, default_language)
        const location = meeting.location?.location
        const locationWithPhysicalLocation = `${meeting.location?.physical_location?.name ? `${meeting.location?.physical_location.name} - ` : ''}${meeting.location?.location}`
        const physical_location = meeting.physical_location?.name || ''
        const locationId = meeting.location?._id
        const mood = meeting.happy + meeting.neutral + meeting.sad
        const imageKey = meeting.imageKey
        const improvements = meeting.improvements
        const recognitions = meeting.recognitions
        const employeeSurveys = meeting.employeeSurveys?.filter(e => e.comment).map(e => {
          const employeeSurveyDate = formatIsoDate(e.createdAt, true)
          return {
            date: employeeSurveyDate,
            location: e.location.location,
            physical_location: e.physical_location?.name || '',
            answer: e.answer,
            comment: e.comment,
            deviceId: e.deviceId,
          }
        }) || []
        employeeSurveysData = employeeSurveysData.concat(employeeSurveys);
        meetings_data.push({
            date,
            dateString,
            start_time: meeting.partial ? meeting.partialStart : meeting.start,
            end_time: meeting.partial ? meeting.partialEnd : meeting.end,
            created_by: meeting.created_by?.name,
            location: location,
            physical_location: physical_location || '',
            happy: meeting.happy,
            neutral: meeting.neutral,
            sad: meeting.sad,
            happiness_index: happinessIndex(meeting.happy, meeting.neutral, meeting.sad),
            happiness_index_text: function() {
              if (!this.happy && !this.neutral && !this.sad) return "-"
              return `${this.happiness_index}%`
            },
            imageKey,
            improvements,
            recognitions,
            id: meeting._id,
            employeeSurveys,
            partial: meeting.partial || false,
            suggested_behaviour_name: meeting.suggested_behaviour?.name || null,
            suggested_behaviour_id: meeting.suggested_behaviour?._id || null,
        });
        happiness_data.happy += meeting.happy
        happiness_data.neutral += meeting.neutral
        happiness_data.sad += meeting.sad

        // Data for charts
        if (locationWithPhysicalLocation) {
          // Bar chart
          if (locationData.hasOwnProperty(locationWithPhysicalLocation)) {
            locationData[locationWithPhysicalLocation].dialogues++
            locationData[locationWithPhysicalLocation].happy += meeting.happy
            locationData[locationWithPhysicalLocation].neutral += meeting.neutral
            locationData[locationWithPhysicalLocation].sad += meeting.sad
          } else {
            locationData[locationWithPhysicalLocation] = {
              dialogues: 1,
              happy: meeting.happy,
              neutral: meeting.neutral,
              sad: meeting.sad,
              id: locationId,
            }
          }

          // Heat map
          if (!locationDataDaily.hasOwnProperty(locationWithPhysicalLocation)) {
            locationDataDaily[locationWithPhysicalLocation] = JSON.parse(JSON.stringify(dailyDialoguesData))
            locationDataDaily[locationWithPhysicalLocation].id = locationId
            locationDataDaily[locationWithPhysicalLocation].dailyDialoguesCount = meeting.location?.dailyDialoguesCount ?? 1
          }
          locationDataDaily[locationWithPhysicalLocation][dateString].dialogues++
          locationDataDaily[locationWithPhysicalLocation][dateString].images += imageKey ? 1 : 0
          locationDataDaily[locationWithPhysicalLocation][dateString].mood += mood
          locationDataDaily[locationWithPhysicalLocation][dateString].improvements += improvements?.length || 0
          locationDataDaily[locationWithPhysicalLocation][dateString].recognitions += recognitions?.length || 0
          locationDataDaily[locationWithPhysicalLocation].total++
        }
      }

      // Global values
      meetings.value = meetings_data
      meetings_total.value = meetings_data.length
      happiness_index.value = (!happiness_data.happy && !happiness_data.neutral && !happiness_data.sad)
        ? "-"
        : `${happinessIndex(happiness_data.happy, happiness_data.neutral, happiness_data.sad)}%`
      totalEmployeeSurveys.value = employeeSurveysData
      comments_total.value = employeeSurveysData.length

      // Unique comments: one per distinct deviceId; surveys without deviceId count as unique
      const uniqueDevices = new Set()
      let commentsWithoutDevice = 0
      for (const survey of employeeSurveysData) {
        if (survey.deviceId) uniqueDevices.add(survey.deviceId)
        else commentsWithoutDevice++
      }
      comments_unique.value = uniqueDevices.size + commentsWithoutDevice

      // Compliance
      let expectedDialoguesTotal = 0
      let dialoguesToComputeTotal = 0

      if (!allLocationsData.value?.length) await getLocationsData()

      // selectedLocationsData.value = locationFilter.value?.length
      //   ? allLocationsData.value?.filter(loc => locationFilter.value?.includes(loc._id?.toString()))
      //   : allLocationsData.value?.filter(loc => locations.value?.map(l => l.value)?.includes(loc._id?.toString()))

      const selectedLocationsIds = []

      for (const location in locationDataDaily) {
        selectedLocationsIds.push(locationDataDaily[location].id)
      }

      selectedLocationsData.value = allLocationsData.value?.filter(loc => selectedLocationsIds.includes(loc._id?.toString()))
      
      // Compliance calculation by location
      for (const loc of selectedLocationsData.value) {
        const dailyDialoguesCount = loc.dailyDialoguesCount ?? 1
        // const dailyDialoguesCount = loc.dailyDialoguesCount || 1

        if (dailyDialoguesCount === 0) continue

        const rawDays = loc.dailyDialogueDays || [1, 2, 3, 4, 5, 6, 0]
        loc.dailyDialogueDays = getOrderedDays(rawDays, default_language)
        // Calculation of days considered
        let qDays = 0
        if (endFilter < now) qDays = dateDiffInDays(startFilter, endFilter, loc.dailyDialogueDays)
        else if (startFilter < now) qDays = dateDiffInDays(startFilter, now, loc.dailyDialogueDays)
  
        loc.qDays = qDays
        loc.expectedDialogues = qDays * dailyDialoguesCount

        // Calculation of actual dialogues completed (don't consider the extra dialogues made if they exceeded dailyDialoguesCount, since the compliance is calculated based on the expected dialogues)
        let dialoguesToCompute = 0
        const locWithPhysicalLocation = `${loc.physical_location?.name ? `${loc.physical_location.name} - ` : ''}${loc.location}`

        if (locationDataDaily[locWithPhysicalLocation]) {
          for (const date in locationDataDaily[locWithPhysicalLocation]) {
            dialoguesToCompute += Math.min(locationDataDaily[locWithPhysicalLocation][date].dialogues || 0, dailyDialoguesCount)
          }
        }

        loc.compliance = loc.expectedDialogues === 0
          ? "-"
          : `${Math.min(100, Math.round((dialoguesToCompute / loc.expectedDialogues) * 1000) / 10)}%`;

        // Global accumulators
        expectedDialoguesTotal += loc.expectedDialogues
        dialoguesToComputeTotal += dialoguesToCompute
      }

      // Calculation of overall adherence
      compliance.value = expectedDialoguesTotal === 0
        ? "-"
        : `${Math.min(100, Math.round((dialoguesToComputeTotal / expectedDialoguesTotal) * 1000) / 10)}%`

      // const qLocations = locationFilter.value.length ? locationFilter.value.length : locations.value.length
      // // const filterDate = new Date(yearFilter.value, monthFilter.value + 1, 0)   // Last day of month of the filter date
      // let qDays = 0
      // // if (monthFilter.value === now.getMonth() && yearFilter.value === now.getFullYear()) qDays = now.getDate()
      // // else if (filterDate < now) qDays = filterDate.getDate()
      // if (endFilter < now) qDays = dateDiffInDays(startFilter, endFilter)
      // else if (startFilter < now) qDays = dateDiffInDays(startFilter, now)
      // compliance.value = complianceIndex(meetings_total.value, qLocations, qDays)

      // Sort charts data
      for (const location in locationData) {
        locationData[location].happinessIndex = happinessIndex(locationData[location].happy, locationData[location].neutral, locationData[location].sad)
      }

      let locationDataSortedByDialogues = Object.entries(locationData)
      let locationDataSortedByHappiness = Object.entries(locationData)

      locationDataSortedByDialogues.sort(function (a, b) {
        return b[1].dialogues - a[1].dialogues
      })

      locationDataSortedByHappiness.sort(function (a, b) {
        return b[1].happinessIndex - a[1].happinessIndex
      })

      const dataLimit = 10 // Display only the first 10 values in the chart
      const dialogueslimit = locationDataSortedByDialogues.length < dataLimit ? locationDataSortedByDialogues.length : dataLimit
      const happinessLimit = locationDataSortedByHappiness.length < dataLimit ? locationDataSortedByHappiness.length : dataLimit
      let locationDialoguesLabels = []
      let locationDialoguesValues = []
      let locationDialoguesIds = []
      let locationHappinessLabels = []
      let locationHappinessValues = []
      let locationHappinessIds = []

      for (let i = 0; i < dialogueslimit; i++) {
        locationDialoguesLabels.push(locationDataSortedByDialogues[i][0])
        locationDialoguesValues.push(locationDataSortedByDialogues[i][1].dialogues)
        locationDialoguesIds.push(locationDataSortedByDialogues[i][1].id)
      }

      for (let i = 0; i < happinessLimit; i++) {
        locationHappinessLabels.push(locationDataSortedByHappiness[i][0])
        locationHappinessValues.push(locationDataSortedByHappiness[i][1].happinessIndex)
        locationHappinessIds.push(locationDataSortedByHappiness[i][1].id)
      }

      locationDialogues.value = {
        labels: locationDialoguesLabels,
        data: locationDialoguesValues,
        additionalInfo: {
          locationIds: locationDialoguesIds,
        }
      }

      locationHappiness.value = {
        labels: locationHappinessLabels,
        data: locationHappinessValues,
        additionalInfo: {
          locationIds: locationHappinessIds,
        }
      }

      // Heat map
      const heatMapData = []

      for (const location in locationDataDaily) {
        const heatMapLocationData = {
          name: location,
          data: [],
          total: locationDataDaily[location].total,
          locationId: locationDataDaily[location].id,
          dailyDialoguesCount: locationDataDaily[location].dailyDialoguesCount
        }

        delete locationDataDaily[location].total
        delete locationDataDaily[location].id
        delete locationDataDaily[location].dailyDialoguesCount

        for (const date in locationDataDaily[location]) {
          heatMapLocationData.data.push({
            x: date,
            y: locationDataDaily[location][date].dialogues,
            images: locationDataDaily[location][date].images,
            mood: locationDataDaily[location][date].mood,
            improvements: locationDataDaily[location][date].improvements,
            recognitions: locationDataDaily[location][date].recognitions
          })
        }

        heatMapData.push(heatMapLocationData)
      }

      // Sort heat map data
      heatMapData.sort(function (a, b) {
        if (b.total === a.total) {
          if (a.name > b.name) return -1
          if (a.name < b.name) return 1
          return 0
        }
        return a.total - b.total
      })

      dialoguesPerDay.value = heatMapData
    }

    function getOrderedDays(daysArray, language = 'es') {
      const order = language === 'es'
        ? [1, 2, 3, 4, 5, 6, 0] // L, M, X, J, V, S, D
        : [0, 1, 2, 3, 4, 5, 6] // S, M, T, W, Th, F, Sa

      return daysArray.slice().sort((a, b) => {
        return order.indexOf(a) - order.indexOf(b)
      })
    }

    const getLocationsData = async () => {
      const query = { client_id: oid(client_id), deleted: { $ne: true } }
      try {
        const pipeline = [
          { $match: query },
          {
            $lookup: {
              from: 'physical_location',
              localField: 'physical_location',
              foreignField: '_id',
              pipeline: [  { $project: { name: 1 } },  { $addFields: { _id: { $toString: "$_id" } } } ],
              as: 'physical_location',
            },
          },
          { $addFields: { _id: { $toString: "$_id" }, physical_location: { $arrayElemAt: ["$physical_location", 0] } } },
        ]
      
        allLocationsData.value = await getItemsAggregate({ collection: 'location', pipeline })
      } catch (error) {
        console.log(error)
      }
    }

    // function complianceIndex(dialogues, locations, days) {
    //     if (!locations || !days) return "-"
    //     return `${Math.round(dialogues / (locations * days) * 1000) / 10}%`
    // }

    function updateFilter(data) {
      locationFilter.value = data.locationFilter;
      physicalLocationFilter.value = data.physicalLocationFilter
      dateRangeFilter.value = data.dateRangeFilter;
      zoneFilter.value = data.zoneFilter;
      agencyFilter.value = data.agencyFilter;
      
      listMeetings()
      handleComments(false)
    }

    function updateLocations(data) {
      if (!locations.value.length) {
        locations.value = data;
        listMeetings();
      }
    }

    const handleComments = (showComments, employeeSurveys) => {
      employeeSurveysSelected.value = employeeSurveys || []
      commentsVisible.value = showComments
    }

    const deleteMeeting = async (id, improvements, recognitions) => {
      try {
        const query = { _id: oid(id) }
        const action = { $set: { deleted: true } }
        // Quién y cuándo elimina el diálogo: el updatedBy que agrega el backend lo sobreescribe
        // cualquier escritura posterior sobre el documento
        const dialogueAction = { $set: { deleted: true, deletedBy: oid(worker_id), deletedAt: date(new Date()) } }

        await updateItem({ collection: 'meeting', query, action: dialogueAction })

        listMeetings()
        showSuccessMessage(i18n.t('message.daily_dialogue_remove'))
        
        // Delete improvements associated with daily dialogue
        if (improvements?.length) {
          try {
            await updateItems({ collection: 'improvement', query: { _id: { $in: improvements } }, action })
          } catch (error) {
            console.log(error)
          }
        }

        // Delete recognitions associated with daily dialogue
        if (recognitions?.length) {
          try {
            await updateItems({ collection: 'recognition', query: { _id: { $in: recognitions } }, action })
          } catch (error) {
            console.log(error)
          }
        }
      } catch (error) {
        console.log(error)
        showErrorMessage(i18n.t('message.daily_dialogue_remove_error'))
      }
    }

    const openBehaviourDetail = (behaviourId) => {
      if (!behaviourId) return
      const resolved = router.resolve({ name: 'organization-behaviour-edit', params: { id: behaviourId }, query: { view: 'true' } })
      window.open(resolved.href, '_blank')
    }

    const openModal = () => {
      uploadImage()
    }

    const uploadImage = () => {
      compressor.value.$el.click()
    }

    const getImgCompressed = (obj) => {
      imgData.value = {
        fileInfo: obj.compressed,
        destinationFolder: `${userData.client.$oid}/daily-dialogues`
      }
    }

    const hideAction = () => {
      imgData.value = {}
    }

    const saveImgInAWS = async (id) => {
      isLoading.value = true
      try {
       const key =  await uploadFileToS3(imgData.value.fileInfo, imgData.value.destinationFolder)
       await updateDailyDialogueWithKey(id, key)
       listMeetings()
      } catch (err) {
        console.log(err)
      }
      isLoading.value = false
    }

    onMounted(() => {
      listMeetings()
    })

    return {
      meetings,
      meetings_total,
      happiness_index,
      compliance,
      updateFilter,
      updateLocations,
      excelFieldsDialogues,
      excelFieldsComments,
      openImage,
      locationDialogues,
      locationHappiness,
      isLoading,
      zone_agency_filter,
      userRole,
      deleteMeeting,
      dialoguesPerDay,
      commentsVisible,
      handleComments,
      employeeSurveysSelected,
      stateVariants,
      totalEmployeeSurveys,
      comments_total,
      comments_unique,
      openModal,
      compressor,
      imgData,
      uploadImage,
      getImgCompressed,
      hideAction,
      saveImgInAWS,
      colors,
      selectedLocationsData,
      showComplianceDetails,
      default_language,
      behaviorFunctionalityDD,
      openBehaviourDetail,
      canSeeComments,
    };
  },
};
</script>

<style scoped>
.hover-card {
  transition: all 0.2s ease-in-out;
}

.hover-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.behaviour-link {
  cursor: pointer;
}

.behaviour-link:hover {
  text-decoration: underline;
}
</style>